"use strict";

var PropTypes = require('prop-types');

var compose = require('../hoc/compose');

var template = require('./panelHeaderCenteredText.jsx');

var textTypes = require('../controls/textTypes');

var PanelHeaderCenteredText = template;
PanelHeaderCenteredText.displayName = 'PanelHeaderCenteredText';
PanelHeaderCenteredText.propTypes = {
  title: PropTypes.string.isRequired,
  titleType: PropTypes.oneOf(textTypes.PANEL_HEADER_CENTERED_TEXT_TITLE_TYPES),
  subtitle: PropTypes.string,
  onHelp: PropTypes.func,
  onClose: PropTypes.func
};
PanelHeaderCenteredText.defaultProps = {
  titleType: textTypes.PANEL_HEADER_CENTERED_TEXT_TITLE_DEFAULT_TYPE
};
module.exports = compose(PanelHeaderCenteredText);